import App from "../packages/offer-calculator/App";
import { createRoot } from "react-dom/client";
const domNode = document.getElementById("react-offer-calculator");
if (domNode) {
    const root = createRoot(domNode);
    root.render(<App />);
}
